module.exports = __webpack_public_path__ + "img/cb9-l-010.ac56f543.gif";